module.exports = __webpack_public_path__ + "static/media/close-img-white.5a2a2c75.svg";